// extracted by mini-css-extract-plugin
module.exports = {"pullQuote":"pullQuote___3hVR9","small":"small___VxrFw","medium":"medium___3yGFC","large":"large___3fQfA","grid":"grid___3oj1j","inner":"inner___I4i6A","content":"content___3NEfk"};